import { Button } from "components/Core/Button";
import { DropDown } from "components/Core/DropDown";
import ModalSkeleton from "modals/ModalSkeleton";
import { useEffect, useState } from "react";
import classes from "./ChangeStatusModal.module.css";

export default function ChangeStatusModal({
  show,
  setShow,
  selectedStatus,
  onclick,
  loading,
}) {
  const [status, setStatus] = useState("");

  useEffect(() => {
    setStatus(
      () =>
        statusOptions.find((item) => item.value === selectedStatus) ||
        statusOptions[0]
    );
  }, []);
  return (
    <ModalSkeleton
      show={show}
      setShow={setShow}
      header={"Change Status"}
      showCloseIcon={true}
    >
      <div className={classes.container}>
        <DropDown options={statusOptions} value={status} setter={setStatus} />
        <div className={classes.btn}>
          <Button
            label={loading ? "Saving..." : "Save"}
            onClick={() => onclick(status?.value)}
            disabled={loading}
          />
        </div>
      </div>
    </ModalSkeleton>
  );
}

const statusOptions = [
  { label: "Completed", value: "completed" },
  { label: "New", value: "new" },
  { label: "Pending", value: "pending" },
];
